import React from "react";
import { useTheme } from "@glossy";
import { IllustrationProps } from ".";

export default ({ colors: { base } }: IllustrationProps) => {
  const theme = useTheme();

  return (
    <svg viewBox="0 0 64 48" width="100%" height="100%">
      <path
        fill="none"
        stroke={base}
        strokeLinecap="round"
        strokeWidth="4"
        d="M13 13h38M13 24h38M13 35h24"
      />
      <rect
        width="63"
        height="47"
        x=".5"
        y=".5"
        fill="none"
        stroke={theme.border}
        rx="6"
        ry="6"
      />
    </svg>
  );
};
